import { FC, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import { useMethods } from '@lhb/hook';
import V2Title from '@/common/components/Feedback/V2Title';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';

const ReportActions: FC<{ development: boolean; onPreview: () => void }> = ({ development, onPreview }) => {
  const [confirming, setConfirming] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const methods = useMethods({
    open() { setConfirming(true); },
    close() { setConfirming(false); },
    submit() { setSubmitted(true); setConfirming(false); },
  });
  return <>
    <Space>
      <Button disabled={!development} onClick={onPreview}>{development ? '分享预览（模拟）' : '分享'}</Button>
      <Button type='primary' disabled={!development || submitted} onClick={methods.open}>{submitted ? '已提交（模拟）' : '提交审批'}</Button>
    </Space>
    <Modal title={<V2Title type='H2' text='审批交互验证' />} visible={confirming} onCancel={methods.close} onOk={methods.submit} okText='模拟提交' destroyOnClose>
      <V2DetailItem label='运行环境' value='隔离的开发模拟数据' />
      <V2DetailItem label='提交范围' value='仅更新当前预览状态，不发起真实审批' />
    </Modal>
  </>;
};
export default ReportActions;
